import { render, staticRenderFns } from "./AlertRule.vue?vue&type=template&id=660e35a0"
import script from "./AlertRule.vue?vue&type=script&lang=js"
export * from "./AlertRule.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports